// import Ajv, { type SchemaObject } from 'ajv/dist/2020.js';
// import ajvErrors from 'ajv-errors';
import { AUTHENTICATION_TLMD_SCHEMAS } from './authentication.schema.js';
import { DOMAIN_TLMD_SCHEMAS } from './domain.schema.js';
import { RESELLER_TLMD_SCHEMAS } from './reseller.schema.js';
import { ROLE_TLMD_SCHEMAS } from './role.schema.js';
import { USER_TLMD_SCHEMAS } from './user.schema.js';
import { COMMON_TLMD_SCHEMAS } from './common.schema.js';
import { getInlineJSONSchema, getJSONSchema, getTLMDSchema, getValidator, } from './schemas.js';
import { AuthenticationSchemaIds, AuthenticationUsageIds, } from './authentication.const.js';
import { DomainSchemaIds, DomainUsageIds } from './domain.const.js';
import { ResellerSchemaIds, ResellerUsageIds } from './reseller.const.js';
import { RoleSchemaIds, RoleUsageIds } from './role.const.js';
import { UserSchemaIds, UserUsageIds } from './user.const.js';
import { dictionaries } from '../i18n/index.js';
import { Locale } from '../i18n/translatable.js';
//fix to deal with NodeNext module resolution https://github.com/ajv-validator/ajv/issues/2132
//import Ajv from 'ajv';
import _Ajv from 'ajv/dist/2020.js';
import _ajvErrors from 'ajv-errors';
const Ajv = _Ajv;
const ajvErrors = _ajvErrors;
export const TLMD_SCHEMA_IDS = {
    ...AuthenticationSchemaIds,
    ...DomainSchemaIds,
    ...ResellerSchemaIds,
    ...RoleSchemaIds,
    ...UserSchemaIds,
};
export const TLMD_USAGE_IDS = [
    ...AuthenticationUsageIds,
    ...DomainUsageIds,
    ...ResellerUsageIds,
    ...RoleUsageIds,
    ...UserUsageIds,
];
export const TLMD_SCHEMAS = (Object.assign({}, COMMON_TLMD_SCHEMAS, AUTHENTICATION_TLMD_SCHEMAS, DOMAIN_TLMD_SCHEMAS, RESELLER_TLMD_SCHEMAS, ROLE_TLMD_SCHEMAS, USER_TLMD_SCHEMAS));
export const addTLMDSchema = (tlmdSchema) => {
    TLMD_SCHEMAS[tlmdSchema.id] = tlmdSchema;
    //prime immediately
    return getTLMDSchema(tlmdSchema.id, TLMD_SCHEMAS, ajv);
};
//set up the base schemas in ajv first
//merge all base schemas here
const tlmdBaseSchemas = Object.assign({}, COMMON_TLMD_SCHEMAS);
//set up ajv, primed with all base schemas
export const ajv = new Ajv({
    allErrors: true,
    schemas: Object.values(tlmdBaseSchemas).map((tlmdSchema) => {
        return getJSONSchema(tlmdSchema, Locale.en, dictionaries[Locale.en]);
    }),
});
ajvErrors(ajv);
export const tlmdSchema = (schema, operation) => {
    return getTLMDSchema(schema, TLMD_SCHEMAS, ajv, operation);
};
export const inlineJSONSchema = (schema, list = false) => {
    const inlineSchema = getInlineJSONSchema(schema, TLMD_SCHEMAS, ajv);
    if (inlineSchema && list) {
        return {
            $schema: inlineSchema.$schema,
            $id: `${inlineSchema.$id}List`,
            title: `${inlineSchema.title} list`,
            description: `${inlineSchema.description} list`,
            type: 'array',
            items: inlineSchema,
            default: []
        };
    }
    return inlineSchema;
};
export const validator = (schema) => {
    return getValidator(schema, TLMD_SCHEMAS, ajv);
};
